export default __webpack_public_path__ + "static/Adelle-Light-d556f5d7567467024711d39f53f280bf.woff2";